<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="分类名称" prop="subjectName">
      <a-input v-model="form.subjectName" placeholder="请输入分类名称" />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ offset: 4, span: 10 }">
      <a-button style="margin-right: 10px" @click="handleCancle"> 取 消 </a-button>

      <a-button type="primary" @click="handleSubmit"
        >
        确定
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { addSubjectItemApi, updateSubjectItemApi } from '@/api/TopicCrawl/WiliType'
import { uploadFileApi } from '@/api/Common/File'

export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {
        subjectId: '',
        subjectName: '',
        type: 'wiki', //默认是维基百科，
        icon: '',
        tempIcon: '',
        isDefault: -1,
        subjectDesc: null
      },
      rules: {
        subjectName: [{ required: true, message: '分类名称不可为空', trigger: ['change', 'blur'] }]
      },
      uploadLoading: false,
      tempUrl: null,
      isDefault: -1
    }
  },
  props: ['formModel'],
  created: function () {
    this.initDefault()
  },
  methods: {
    initDefault() {
      if (this.formModel && this.formModel.subjectId != null && this.formModel.subjectId != '') {
        this.form = this.formModel
      } else {
        this.form = {
          subjectId: '',
          subjectName: '',
          type: 'wiki', //默认是维基百科，
          icon: '',
          tempIcon: '',
          isDefault: -1,
          subjectDesc:null
        }
      }

      if (!this.form.type) {
        this.form.type = 'wiki'
      }
      if (this.form.isDefault == null) {
        this.form.isDefault = -1
      }
      this.tempUrl = this.form.tempIcon
      this.isDefault = this.form.isDefault
    },
    handleClose() {
      this.$emit('onSubmitSuccess')
    },

    handleCancle() {
      this.$emit('onClose')
    },
    async addSubjectItem() {
      let res = await addSubjectItemApi({ ...this.form })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.initDefault()
        this.handleClose()
      } else {
        this.$message.error(msg)
      }
    },

    async updateSubjectItem() {
      let res = await updateSubjectItemApi({ ...this.form })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.handleClose()
      } else {
        this.$message.error(msg)
      }
    },

    handleSubmit() {
      this.form.isDefault = this.isDefault
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateSubjectItem()
          } else {
            this.addSubjectItem()
          }
        } else {
          return false
        }
      })
    },
    async changeUploadFile(info) {
      this.uploadLoading = true
      let fileData = new FormData()
      fileData.append('file', info.file)
      let res = await uploadFileApi(
        { path: 'files/orion/image/', width: 102, height: 102 },
        fileData
      )
      this.uploadLoading = false
      const { extra, code, msg } = res
      if (code == '200') {
        this.$message.success('上传成功')
        this.tempUrl = extra.tempUrl
        this.form.icon = extra.url
        this.form.tempIcon = this.tempUrl
      } else {
        this.$message.error('上传失败')
      }
    }
  },
  watch: {
    formModel: {
      handler() {
        this.initDefault()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.ant-upload-text {
  color: #9999;
}
// .plus{
//     color: #9999;

// }
</style>
`
